import { BootstrapResponse, BootstrapResponseEvent } from "../models/api";
import { Player, Team } from "../models";

export const POSITIONS = ["-", "GK", "DEF", "MID", "FWD"];

export const playersFrom = (bootstrap: BootstrapResponse): Player[] => {
	const shortNames = new Map(bootstrap.teams.map((t) => [t.id, t.short_name]));
	return bootstrap.elements.map((p) => ({
		id: p.id,
		name: p.web_name,
		position: POSITIONS[p.element_type],
		team: p.team,
		teamShort: shortNames.get(p.team) ?? "",
		type: p.element_type,
		ineligable: p.chance_of_playing_this_round === 0,
		expectedPoints: Number(p.ep_this ?? 0) || 0,
	}));
};

export const teamsFrom = (bootstrap: BootstrapResponse): Team[] => bootstrap.teams.map((t) => ({ id: t.id, name: t.name, shortName: t.short_name }));

export const currentEvent = (bootstrap: BootstrapResponse): BootstrapResponseEvent | undefined => bootstrap.events.find((x) => x.is_current);

export const eventById = (bootstrap: BootstrapResponse, id: number): BootstrapResponseEvent | undefined => bootstrap.events.find((x) => x.id === id);
